import { render, staticRenderFns } from "./StudentOuStructure.vue?vue&type=template&id=76eea3c6&lang=pug&"
import script from "./StudentOuStructure.vue?vue&type=script&lang=js&"
export * from "./StudentOuStructure.vue?vue&type=script&lang=js&"
import style0 from "./StudentOuStructure.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports